module.exports = __webpack_public_path__ + "static/media/closing-img.8295a43c.png";